module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/aviso-sin-foto.7ec090ef.svg";